let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fPhbw")).then(() => parcelRequire('hHiui'));